{
  "version": 1,
  "manual": [
    { "slug": "action", "ar": "أكشن", "en": "Action" },
    { "slug": "drama", "ar": "دراما", "en": "Drama" },
    { "slug": "sci-fi", "ar": "خيال علمي", "en": "Sci-Fi" },
    { "slug": "thriller", "ar": "إثارة", "en": "Thriller" },
    { "slug": "comedy", "ar": "كوميديا", "en": "Comedy" },
    { "slug": "romance", "ar": "رومانسي", "en": "Romance" }
  ]
}
